// @flow
import * as React from 'react';
import classNames from 'classnames';
import { type CoverLots } from '../../types/CoverLot';
import { getCoverLotUrls } from '../../utils/urls';
import ImageWithFallback from '@liveauctioneers/caterwaul-components/lib/ImageWithFallback/ImageWithFallback';
import isEqual from 'react-fast-compare';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import styles from './CoverLotsComponent.module.scss';

type Props = {
    catalogId: number,
    catalogUrl?: string,
    className: string,
    coverLots: CoverLots,
    featured: boolean,
    isSEOExcluded: boolean,
    sellerId: number,
    skipVisibilityCheck?: boolean,
};

// these are temporary - hopefully
const customImages = {
    '146331': 'https://images.liveauctioneers.com/static/mail/images/featured/20190724_handbags.gif',
    '146504': 'https://images.liveauctioneers.com/static/mail/images/featured/20190724_stair.gif',
};

const CoverLotsComponent = ({
    catalogId,
    catalogUrl,
    className = '',
    coverLots,
    featured = false,
    isSEOExcluded = false,
    sellerId,
    skipVisibilityCheck,
}: Props) => {
    const { primary, secondary1, secondary2 } = getCoverLotUrls(
        catalogId,
        coverLots,
        sellerId,
        270,
        coverLots?.results?.length === 2 ? 270 : 170,
        170,
        catalogUrl
    );

    const classes = classNames(styles['cover-lots'], className, { [styles.featured]: featured });
    const primaryImageClasses = classNames(styles['primary-img-container'], {
        [styles.singlePrimary]: coverLots?.results?.length === 1,
        [styles.doublePrimary]: coverLots?.results?.length === 2,
    });
    const secondaryImageClasses = classNames(styles['secondary-img-container'], {
        [styles.singleSecondary]: coverLots?.results?.length === 1,
        [styles.doubleSecondary]: coverLots?.results?.length === 2,
    });

    // Add a custom first image for this particular auction.
    // TODO: If we decide to do this more often we need a better way
    const primaryImageUrl = customImages[catalogId] || primary.imageSrc;
    const linkRel = isSEOExcluded ? 'nofollow' : '';

    return (
        <div className={classes}>
            <div className={styles['one-and-two-wrapper']}>
                <Link route to={primary.imageHref} className={primaryImageClasses} rel={linkRel}>
                    <ImageWithFallback
                        className={styles.primary}
                        src={primaryImageUrl}
                        alt={primary.imageAlt}
                        skipVisibilityCheck={skipVisibilityCheck}
                    />
                </Link>
                <div className={secondaryImageClasses}>
                    <Link route to={secondary1.imageHref} className={styles['img-container']} rel={linkRel}>
                        <ImageWithFallback
                            className={styles.secondary}
                            src={secondary1.imageSrc}
                            alt={secondary1.imageAlt}
                            skipVisibilityCheck={skipVisibilityCheck}
                        />
                    </Link>
                    <Link route to={secondary2.imageHref} className={styles['img-container']} rel={linkRel}>
                        <ImageWithFallback
                            className={styles.secondary}
                            src={secondary2.imageSrc}
                            alt={secondary2.imageAlt}
                            skipVisibilityCheck={skipVisibilityCheck}
                        />
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default React.memo<Props>(CoverLotsComponent, isEqual);
